module.exports = __webpack_public_path__ + "img/stronghold_small.c0b725d1.png";